export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12854.8c022cd5.jpg";